<script setup lang="ts">
  // Temp fix to the hydration mismatch issue with SSR on Vue 3.4
  // (radix component ID's not matching between server and client)
  // This should be resolved in Vue 3.5, when it comes out
  const useIdFn = () => useId().replace(/[-:]/, '_')

  const {
    public: { gtmNew, gtmOld }
  } = useRuntimeConfig()
</script>

<template>
  <ConfigProvider :use-id="useIdFn">
    <NuxtLayout>
      <span
        id="a11y-alerts"
        class="sr-only"
        aria-live="polite"
        role="status"
      />

      <MainWrapper>
        <NuxtPage />
      </MainWrapper>

      <StoryblokEditorLink />
    </NuxtLayout>
  </ConfigProvider>
  <ClientOnly>
    <noscript
      v-if="gtmNew"
      data-cookieconsent="ignore"
    >
      <iframe
        :src="`https://www.googletagmanager.com/ns.html?id=${gtmNew}`"
        title="Google Tag Manager New"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
    <noscript
      v-if="gtmOld"
      data-cookieconsent="ignore"
    >
      <iframe
        :src="`https://www.googletagmanager.com/ns.html?id=${gtmOld}`"
        title="Google Tag Manager Old"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
  </ClientOnly>
</template>
